<template>
<div class="container">
    <div class="text-center" style="font-size: 8rem">WIP</div>
    <div class="text-center" style="font-size: 2rem">开发中</div>
    <div class="text-center" style="font-size: 2rem">请访问其他页面</div>
</div>
</template>

<script setup lang="ts">
useHead({ title: '首页' });
</script>
